import script from "./CardLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./CardLayout.vue?vue&type=script&setup=true&lang=js"

import "./CardLayout.vue?vue&type=style&index=0&id=353d9a31&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-353d9a31"]])

export default __exports__